import { Action, ServerActionDefinition } from "components/actions/actions";
import { Renderer } from "components/Renderer";
import { TableData } from "components/table/table";
import { ActionColumnDefinition } from "components/table/columns/ColumnDefinitions";
import i18n from "components/i18n/i18n";
import {
    ItemComposedFinderModalDefinition,
    ItemFinderModalDefinition,
    ItemFinderModalParams,
    ItemComposedFinderModalSelection,
    ItemFinderModalSelection,
} from "components/input/searcherWithCode/baseItemFinderElement";
import set from "lodash/set";
import "jquery-ui/ui/widgets/dialog";

import "./searcherWithSingleCode/itemFinderModal.scss";
import "./searcherWithComposedCode/itemComposedFinderModal.scss";

let modal: JQuery<HTMLElement>;
const componentTypeFilter = ['textInput', 'codeInput', 'dateInput', 'dateTimeInput'];

export function map(typeEnumSearcherWith: EnumSearcherWithType, definition: ItemFinderModalDefinition | ItemComposedFinderModalDefinition, data: any) {

    let code: any;
    if (data == null) {
        code = null;
    } else {
        if (typeEnumSearcherWith == EnumSearcherWithType.COMPOSE) {
            code = getCodeCompose(definition, data);








        } else {
            code = getCodeSingle(definition, data);
        }
    }

    let detail: string;
    if (code == null) {
        detail = null;
    } else {
        detail = data[definition.detailAttribute] ?? "";
    }

    let returned: ItemFinderModalSelection | ItemComposedFinderModalSelection = {
        detail,
        code,
    };

    if (definition.outputParameterMappings != null) {
        definition.outputParameterMappings.forEach((val) => set(returned, val.as, data == null ? null : data[val.field]));
    }

    return returned;
}

function getCodeSingle(definition: ItemFinderModalDefinition, data: any) {
    let code: any;
    if (Array.isArray(definition.codeAttributes)) {
        code = data[definition.codeAttributes[0]];
    } else {
        code = data[definition.codeAttributes];
    }

    return code;
}

function getCodeCompose(definition: ItemComposedFinderModalDefinition, data: any) {
    let code: any;
    //Si es un array, deberia ser una LOV compuesta, sino single
    if (Array.isArray(definition.codeAttributes)) {
        code = {};
        for (let key of definition.codeAttributes) {
            code[key] = data[key];
        }
    } else {
        code = data[definition.codeAttributes];
    }
    return code;
}

export function open(
    type: EnumSearcherWithType,
    definition: ItemFinderModalDefinition | ItemComposedFinderModalDefinition,
    params: ItemFinderModalParams,
    callback: (selection: ItemFinderModalSelection | ItemFinderModalSelection[] | ItemComposedFinderModalSelection | ItemComposedFinderModalSelection[]) => void
) {
    if (definition.table == null) {
        let filterData = {};

        if (params?.data.filter != null) {
            for (const d of params.data.filter) {
                filterData[d.property] = d.value;
            }
        }
        openModal(definition.titleKey);
        new Action({
            actionName: "itemFinderModalAction",
            url: definition.url + "/lov.json",
            httpMethod: "get",
            onBeforeDefaultResponse: (r) => {
                let composedDefinition = { ...definition, table: r.bundle.definition };
                configureTable(type, composedDefinition, callback);
            }
        } as ServerActionDefinition, null).run(filterData);
    } else {
        drawFromDefinition(type, definition, params, callback);
    }
}

function openModal(titleKey) {
    modal = $(
        `<div>
            <div data-s6-id='itemFinderModalTarget'>
            <div class="c-item-finder-modal__holder">
            <i class='fa fa-spinner fa-spin fa-3x fa-fw'></i>
            </div>
            </div>
        </div>`).appendTo("body");
    modal.dialog({
        title: i18n.instance.t(titleKey),
        height: Math.max($(window).height() * .8, 300),
        minHeight: 300,
        maxHeight: 1000,
        minWidth: 400,
        width: Math.min($(window).width() * .8, 900),
        maxWidth: 900,
        modal: true,
        closeText: i18n.instance.t("base.close.action"),
        classes: {
            "ui-dialog": "c-item-finder-modal",
            "ui-dialog-content": "c-item-finder-modal__content",
        },
    });

    modal.on("dialogclose", (event, ui) => {
        modal[0].innerHTML = "";
        modal.dialog("destroy");
        modal[0].remove();
    });
}

function addIconColumn(type: EnumSearcherWithType, definition, callback) {
    (definition.table.columns[0] as ActionColumnDefinition).action = {
        actionName: "itemFinderModalCallback",
        callback: (data: ItemFinderModalSelection | ItemComposedFinderModalSelection) => {
            const returned = map(type, definition, data);
            callback(returned);
            modal.dialog("close");
        },
    };
}

function addCheckColumn(type: EnumSearcherWithType, definition, callback) {
    let mappings;
    if (definition.outputParameterMappings != null) {
        mappings = definition.outputParameterMappings.map((m) => ({ field: m.field, as: m.field }));
    } else {
        definition.outputParameterMappings = definition.table.columns
            .filter((c) => c.property != null)
            .map((c) => ({ field: c.property, as: c.property }));
        mappings = definition.outputParameterMappings;
    }
    definition.table.columns[0] = {
        type: "CheckColumn",
        property: "itemFinderModal_select",
        tooltipKey: "actions.select",
    };
    definition.table.actions = [{
        labelKey: "actions.select",
        componentType: "actionButton",
        id: "itemFinderModal-" + definition.table.id,
        style: "default",
        action: {
            actionName: "itemFinderModalCallback",
            fieldParameterMappings: mappings,
            callback: (data: TableData) => {
                const returned = [];
                for (const d of data.data["itemFinderModal_select"]) {
                    returned.push(map(type, definition, d));
                }
                callback(returned);
                modal.dialog("close");
            },
        },
    }];
}

function configureTable(type: EnumSearcherWithType, definition, callback) {
    if (definition.table.columns[0].tooltipKey == null) {
        definition.table.columns[0].tooltipKey = "actions.select";
    }
    definition.table.preventLoss = false;
    definition.table.fillContainer = true;
    if (definition.isMultiple) {
        addCheckColumn(type, definition, callback);
    } else {
        addIconColumn(type, definition, callback);
    }
}

function drawFromDefinition(type: EnumSearcherWithType, definition, params, callback) {

    configureTable(type, definition, callback);
    openModal(definition.titleKey);

    let restrictions = {
        filter: {},
        columns: null,
        actions: null,
    };

    let formData = {
        filter: {},
    };
    if (params?.data != null) {
        for (const key in params.data) {
            if (params.data.hasOwnProperty(key) && params.data[key] != null) {
                const element = params.data[key];
                for (const option of element) {
                    if (option.value != null) {
                        restrictions.filter[option.property] = {
                            attributes: "read-only",
                        };
                    }
                }
            }
        }

        if (params.data.filter != null) {
            for (const d of params.data.filter) {
                formData.filter[d.property] = d.value;
            }
        }
    }

    let bundle = {
        definition: definition.table,
        data: formData,
        options: params?.options,
        restrictions,
    };

    let firstPropertyInput = findFirstPropertyInputInTree(bundle.definition.filter);

    Renderer.instance().fullRender(bundle, modal[0], undefined, undefined, firstPropertyInput);

}

function findFirstPropertyInputInTree(data: any): string {

    if (data.hasOwnProperty("children") && data.children.length != 0) {
        for (const child of data.children) {
            const property = findFirstPropertyInputInTree(child)
            if (property != null) {
                return property;
            }
        }
    } else {
        if (data.hasOwnProperty("componentType") && (componentTypeFilter.indexOf(data.componentType) >= 0)) {
            return data.property;
        }
    }
    return null;
}

export enum EnumSearcherWithType {
    SINGLE,
    COMPOSE,
}
